export default "<mat-progress-bar *ngIf=\"loading\"  mode=\"indeterminate\"> </mat-progress-bar>\n\n<p *ngIf=\"!loading\">\n  Error page not found\n</p>\n\n"